import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentCandidatePage: 1,
  currentInterviewedPage: 1,
  currentPage: 1,  
  currentRejectedPage: 1,
  currentSortedPage: 1,
  subTab: 0,  
};

const paginationSlice = createSlice({
  name: 'pagination',
  initialState,
  reducers: {
    setCurrentCandidatePage: (state, action) => {
      state.currentCandidatePage = action.payload;
    },
    setCurrentInterviewedPage: (state, action) => {
      state.currentInterviewedPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setCurrentRejectedPage: (state, action) => {
      state.currentRejectedPage = action.payload;
    },
    setCurrentSortedPage: (state, action) => {
      state.currentSortedPage = action.payload;
    },
    setSubTab: (state, action) => {
      state.subTab = action.payload;
    },
    
    resetPages: (state) => {
      state.currentCandidatePage = 1;
      state.currentInterviewedPage = 1;
      state.subTab = 0;
      state.currentRejectedPage = 1;
      state.currentSortedPage = 1;
    },
  },
});

export const {
  setCurrentCandidatePage,
  setCurrentInterviewedPage,
  setCurrentPage,
  setCurrentRejectedPage,
  setCurrentSortedPage,
  setSubTab,
  resetPages,
} = paginationSlice.actions;

export default paginationSlice.reducer;
